export default "__VITE_ASSET__a2224721__"